import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Sticky from 'react-stickynode';

import SwymWishlistBtn from '../SwymWishlistBtn/SwymWishlistBtn';
import Image from '../Image';

import useWindowWidth from '../../hooks/useWindowWidth';

import { isGalleryImage, getSelectedOptionValuesAry } from '../../Utils/ProductUtils';

import { ImageGridDiv, MobileCenteringWrapper, SliderWrapper, ImageWrapper } from './ProductGalleryStyles';

var ProductGallery = function ProductGallery(props) {
  var GallerySlider = null;

  var windowWidth = useWindowWidth();

  useEffect(function () {
    // Scroll to first slide on option change
    GallerySlider.slickGoTo(0);
  }, [props.selectedVariant.selectedOptions, GallerySlider]);

  var selectedOptionValuesAry = getSelectedOptionValuesAry(props.selectedVariant.selectedOptions);

  return React.createElement(
    ImageGridDiv,
    { className: 'StickyContainer' },
    React.createElement(
      Sticky,
      {
        top: 120,
        bottomBoundary: '.StickyContainer',
        enabled: windowWidth >= 769
      },
      React.createElement(
        MobileCenteringWrapper,
        { className: 'product--image-outside--background' },
        React.createElement(
          SliderWrapper,
          null,
          React.createElement(
            Slider,
            {
              className: 'ProductSlider',
              infinite: true,
              slidesToShow: 1,
              rows: 1,
              slidesToScroll: 1,
              dots: true,
              ref: function ref(slider) {
                GallerySlider = slider;
              }
            },
            props.product.images.edges.map(function (image) {
              if (isGalleryImage(image, props.selectedVariant.image.productImg, selectedOptionValuesAry)) {
                return React.createElement(
                  ImageWrapper,
                  { key: image.node.productImg },
                  React.createElement(Image, {
                    src: image.node.productImg + '&width=500',
                    alt: image.node.altText
                  })
                );
              } else return null;
            })
          )
        )
      )
    )
  );
};

ProductGallery.propTypes = {
  product: PropTypes.object,
  selectedVariant: PropTypes.object.isRequired,
  isWishlistProduct: PropTypes.bool,
  toggleAccountModal: PropTypes.func.isRequired
};

export default React.memo(ProductGallery);